// extracted by mini-css-extract-plugin
export default {"container":"un-z","blurb":"vn-z","links":"wn-z"};